import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useState, useEffect, useLayoutEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import usePrevious from '@elliemae/ds-utilities/hooks/usePrevious';
import useShouldRecalculate from '@elliemae/ds-utilities/hooks/useShouldRecalculate';
import { isFunction, isString } from '@elliemae/ds-utilities/utils';
import { DropdownPill } from '../DropdownPill.js';
import { InputPill } from '../InputPill.js';
import { Pill } from '../Pill.js';
import { RemovablePill } from '../RemovablePill.js';
import { hasOptionChanged } from './utils.js';
import 'react-desc';
import '@elliemae/ds-dropdownmenu';
import '@elliemae/ds-icons/ChevronDown';
import '@elliemae/ds-shared/FocusGroup/useFocusGroupItem';
import '@elliemae/ds-icons/CloseXsmall';
import '@elliemae/ds-classnames';
import '@elliemae/ds-form/InputMask';
import '@elliemae/ds-form/Input';
import 'lodash';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function LabeledDropdownSinglePill(_ref) {
  var label = _ref.label,
      _ref$labelIsValue = _ref.labelIsValue,
      labelIsValue = _ref$labelIsValue === void 0 ? false : _ref$labelIsValue,
      options = _ref.options,
      value = _ref.value,
      _ref$onSelect = _ref.onSelect,
      onSelect = _ref$onSelect === void 0 ? function () {
    return null;
  } : _ref$onSelect,
      onChange = _ref.onChange,
      maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth,
      _ref$fixed = _ref.fixed,
      fixed = _ref$fixed === void 0 ? false : _ref$fixed,
      menuProps = _objectWithoutProperties(_ref, ["label", "labelIsValue", "options", "value", "onSelect", "onChange", "maxWidth", "minWidth", "fixed"]);

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      optionValue = _useState2[0],
      setOptionValue = _useState2[1];

  var prevOptions = usePrevious(options);
  var areOptionsEqual = useShouldRecalculate(hasOptionChanged(prevOptions, options));
  useEffect(function () {
    return setOptionValue(value);
  }, [value]);
  useEffect(function () {
    var selectedValue = options.find(function (option) {
      return option.selected;
    });

    if (selectedValue) {
      setOptionValue(selectedValue);
    } else if (!selectedValue) {
      setOptionValue(options[0]);
    }
  }, [areOptionsEqual]);
  useLayoutEffect(function () {
    if (optionValue) {
      var selectedValue = options.find(function (option) {
        return option.id === optionValue.id;
      });
      setOptionValue(selectedValue);
    }
  }, [options]);
  var selectOption = useCallback(function (option) {
    if (isFunction(onChange)) {
      onChange(option);
    }

    setOptionValue(option);
    onSelect(option);
  }, [onChange, onSelect]);
  var onChangeInputValue = useCallback(function (_ref2) {
    var inputValue = _ref2.target.value;
    var onChangeInput = optionValue.onChangeInput;
    onChangeInput && onChangeInput(inputValue);
  }, [optionValue]);

  var removeOption = function removeOption(props) {
    var onRemove = menuProps.onRemove;
    var onChangeInput = optionValue.onChangeInput;
    setOptionValue(null);
    onChangeInput && onChangeInput('');
    onRemove && onRemove(props);
  };

  var renderPill = function renderPill(option, fixed) {
    var input = option.input;
        option.onChangeInput;
        var otherProps = _objectWithoutProperties(option, ["input", "onChangeInput"]);

    var SelectedPill;

    if (isString(input)) {
      SelectedPill = InputPill;
    } else if (fixed) {
      SelectedPill = Pill;
    } else {
      SelectedPill = RemovablePill;
    }

    return /*#__PURE__*/React.createElement(SelectedPill, _extends({
      key: option.id,
      label: option.label,
      onChange: onChangeInputValue,
      onRemove: function onRemove(e) {
        return removeOption(option);
      },
      value: input
    }, otherProps));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownPill, _extends({}, menuProps, {
    label: !labelIsValue ? label : optionValue.label,
    maxWidth: maxWidth,
    minWidth: minWidth,
    onSelectMenuItem: selectOption,
    options: [_objectSpread(_objectSpread({}, menuProps), {}, {
      type: 'SelectionGroup',
      id: 'multi-selection-views',
      multi: false,
      items: options,
      closeOnClick: true
    })],
    selection: {
      'multi-selection-views': optionValue ? [optionValue.id] : ''
    },
    variant: "title"
  })), optionValue ? renderPill(optionValue, fixed) : /*#__PURE__*/React.createElement(Pill, {
    label: "-"
  }));
}
LabeledDropdownSinglePill.propTypes = {
  label: PropTypes.string,
  labelIsValue: PropTypes.bool,
  options: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func,
  onChange: PropTypes.func,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  minWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fixed: PropTypes.bool
};

export default LabeledDropdownSinglePill;
//# sourceMappingURL=LabeledDropdownSinglePill.js.map
